import React from 'react';

import { flagStyles } from '../settings';

const SvgCZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1296px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCZ;
